
import React from "react";
import FAQItem from "./FAQItem";

const TechnicalSection: React.FC = () => {
  return (
    <section>
      <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">Technical and Privacy</h2>
      
      <FAQItem question="Is my data secure?">
        <p className="text-foreground">
          We use enterprise-grade security measures including encrypted data transmission, secure storage, and strict privacy controls. Your remote viewing impressions and personal information are never shared or used for any purpose other than providing feedback.
        </p>
      </FAQItem>

      <FAQItem question="Can I access my session history?">
        <p className="text-foreground">
          Yes, all your remote viewing sessions, impressions, and feedback are saved in your personal history, allowing you to track progress and review past sessions.
        </p>
      </FAQItem>

      <FAQItem question="What browsers and devices are supported?">
        <p className="text-foreground">
          RemoteViz works on all modern web browsers (Chrome, Firefox, Safari, Edge) on desktop, tablet, and mobile devices. No downloads or installations required.
        </p>
      </FAQItem>
    </section>
  );
};

export default TechnicalSection;
